import React from 'react'

// styles
import {
    extendStylesSelect,
    extendStylesDropdown,
    DropDownSupervisorStyles,
} from './index.styles'

// component
import DropDownSearch from '../../../../../../Control/DropDownSearch'

const DropdownSupervisor = ({ extendStyles, label, ...props }) => {
    return (
        <>
            <div className="label-tools-item">{label}</div>
            <DropDownSupervisorStyles
                className="tools-item"
                extendStyles={extendStyles}
            >
                <DropDownSearch
                    {...props}
                    extendStylesSelect={extendStylesSelect}
                    extendStylesDropdown={extendStylesDropdown}
                />
            </DropDownSupervisorStyles>
        </>
    )
}

export default DropdownSupervisor
